import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';


//const URL: string = 'http://192.168.0.53:8083/api/';
const URL: string = 'https://indicadoresapi.dilady.com.br/api/';
const API_KEY: string = 'aIf6EtKmTZvNdKhkEAHxSOJeze2b0WcSl0BJA6oZzjg';

@Injectable()
export class Api {
    private _headers: Headers;

    constructor(public http: Http) { }

    public get(endpoint: string): Observable<any> {
        let reqOpts = {
            headers: this._getHeaders()
        };

        return this.http.get(`${URL}${endpoint}`, reqOpts);
    }

    private _getHeaders(): Headers {
        if (!this._headers) {
            this._headers = new Headers();

            this._headers.append('API_KEY', API_KEY);

            return this._headers;
        }

        return this._headers;
    }
}


// WEBPACK FOOTER //
// ./src/providers/api/api.ts